var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grm-input-container" }, [
    _c("input", {
      ref: "input",
      staticClass: "grm-input",
      attrs: {
        type: _vm.type,
        minlength: _vm.minlength,
        maxlength: _vm.maxlength,
        placeholder: _vm.placeholder,
      },
      domProps: { value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event.target.value)
        },
      },
    }),
    _vm.helpText
      ? _c(
          "p",
          { staticClass: "grm-input-help-text", class: _vm.helpTextClass },
          [_vm._v(_vm._s(_vm.helpText))]
        )
      : _vm._e(),
    _c(
      "ul",
      { staticClass: "grm-input-check-list" },
      _vm._l(_vm.checkList, function (checkItem, checkItemIndex) {
        return _c(
          "li",
          { key: checkItemIndex, staticClass: "grm-input-check-item" },
          [
            _c(
              "GrmCheckbox",
              {
                attrs: { disabled: "", id: checkItemIndex },
                model: {
                  value: checkItem.checked,
                  callback: function ($$v) {
                    _vm.$set(checkItem, "checked", $$v)
                  },
                  expression: "checkItem.checked",
                },
              },
              [_vm._v(_vm._s(checkItem.text))]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }